import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DebtorService } from '../../../../_services/index';
import { ParameterData } from '../../../../_helpers/index';
import { Debtor } from '../../../../_models/index';
import { debtordocumenttype, debtorStatus, debtorPhonePrefix, DocumentService } from '../../../../_enums/debtordocumenttype';

@Component({
    selector: 'app-old-customer-company-create',
    templateUrl: './old-customer-create.component.html'
})
export class OldCustomerCompanyCreateComponent implements OnInit {

    public customer_public_id: string

    public debtorForm: FormGroup;
    public debPublicID: any;
    customerPuplic_key: any;
    inputPrefixPhone: any;
    inputPhoneNo: any;
    isEmailEditControlDisabled = false;
    isalertVisiable = false;
    isalertExistVisiable = false;
    isalertErrorVisible = false;
    ddldbdocumenttype: any[];
    ddldebtorStatus: any[];
    ddldebtorPhonePrefix: any[];
    statusresult: any;
    debname: any;
    symbolsValidator = "/^[a-zA-Z0-9\ ]+$/";
    ddldbdocumenttype2: any[];
    ddldebtorPhonePrefix2: any;
    /**
     * constructor function is used to initialize 
     */
    constructor(private parameterData: ParameterData, private debtorService: DebtorService
        , private _fb: FormBuilder, private router: Router,
        private route: ActivatedRoute
        , private documentType: debtordocumenttype
        , private _debtorStatus: debtorStatus
        , private _debtorPhonePrefix: debtorPhonePrefix,
        private ddldbdocumenttype1: DocumentService
    ) {


        this.isEmailEditControlDisabled = false;
        this.isalertVisiable = false;

        this.ddldbdocumenttype = documentType.documenttype;
        this.ddldebtorStatus = _debtorStatus.Status;
        this.ddldebtorPhonePrefix = _debtorPhonePrefix.PhonePrefix;


    }



    /**
     * this InitialSetup function is used to initialize the form controls 
     */
    InitialSetup() {

        this.debtorForm = this._fb.group({
            id: new FormControl(0),
            external_id: new FormControl(""),
            name: new FormControl("", [Validators.required, Validators.maxLength(50), Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")]),
            email: new FormControl("", [Validators.required, Validators.email]),
            phone: new FormControl("", [Validators.required]),
            document_id: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$")]),
            document_type: new FormControl("", [Validators.required]),
            status: new FormControl("Activo"),
            address: this._fb.group({
                id: new FormControl(0),
                street: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                county: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                city: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                state: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                created: new FormControl("0"),
                zip: new FormControl('" "')
            }),
            creditor: this._fb.group({
                public_id: new FormControl(this.customer_public_id)

            })
        });


    }



    /**
     * this ngOnInit function is used to initialize the component after constructor
     */
    ngOnInit() {
        let country = localStorage.getItem('country');
        this.ddldbdocumenttype2 = this.ddldbdocumenttype1.getDocumentsByIsoAlpha2(country);
        this.ddldebtorPhonePrefix2 = this.ddldbdocumenttype1.getPrefixByIsoAlpha2(country);
        window.scroll(0, 0);
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
        }


        this.InitialSetup();
        const toSelect_documenttype = this.ddldbdocumenttype2.find(c => c.iso_alpha_2 == country.toUpperCase());
        this.debtorForm.get('document_type').setValue(toSelect_documenttype.short_name);

        const toSelect_status = this.ddldebtorStatus.find(c => c.value == 'ACTIVE');
        this.debtorForm.get('status').setValue(toSelect_status.value);

        this.inputPrefixPhone = this.ddldebtorPhonePrefix2.prefix;

    }//end



    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
                return false;
            }
        }
        return true;

    }



    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.ctrlKey && event.keyCode == 83) {
            if (this.debtorForm.valid) {
                event.preventDefault();
                this.onsubmit(event, this.debtorForm);
            }
            else {
                event.preventDefault();
            }
        }
    }
    /**
     * this submit function is used to save the data, sends the input data to api
     */
    onsubmit(event, { value }: { value: Debtor }) {
        if (!(this.inputPrefixPhone == undefined || this.inputPrefixPhone == null)) {
            value.phone = this.inputPrefixPhone + this.inputPhoneNo;
        }
        const toget_documenttype = this.ddldbdocumenttype2.find(c => c.short_name == value.document_type);
        console.log(toget_documenttype);
        value.document_type = toget_documenttype.short_name;

        const toget__status = this.ddldebtorStatus.find(c => c.value == value.status);
        value.status = toget__status.value;

        if (value.id === null) {
            value.id = 0;
        }
        if (value.id == 0) {


            this.debtorService.createDebtor(value)
                .subscribe((result) => {


                    if (result.status == "200") {
                        if (result.body.Error == "500") {
                            this.statusresult = result.body.Description;
                            this.isalertExistVisiable = true;
                            this.isalertVisiable = false;
                            this.isalertErrorVisible = false;
                        }
                        else if (result.body.Error == "400") {
                            this.statusresult = "Error actualizando información, revisar datos o reintente denuevo"
                            this.isalertErrorVisible = true;
                            this.isalertExistVisiable = false;
                            this.isalertVisiable = false;
                        }
                        else
                            if (result.body.email == value.email && result.body.external_id == value.external_id) {

                                this.isalertExistVisiable = false;
                                this.isalertVisiable = true;
                                this.isalertErrorVisible = false;
                            }
                            else {
                                this.statusresult = "Cliente con ese email o código ya existe";
                                this.debPublicID = result.body.public_id;
                                this.debname = result.body.name;
                                this.isalertExistVisiable = true;
                                this.isalertVisiable = false;
                                this.isalertErrorVisible = false;
                            }

                    }

                    else if (result.status == "201") {

                        this.router.navigate([`/customers/${result.body.public_id}/view`]);
                        this.isalertExistVisiable = false;
                        this.isalertVisiable = true;
                    }

                }, error => {


                    this.statusresult = "Error actualizando información, revisar datos o reintente denuevo";
                    this.isalertExistVisiable = false;
                    this.isalertVisiable = false;
                    this.isalertErrorVisible = true;
                    console.log('Failed while trying to update the Debtor Details.' + error);
                });

        }
    }//end

    documentTypeChange(documentType) {
        if (documentType === 'OTHER') {
            this.debtorForm.controls.document_id.setValue("");
            this.debtorForm.controls.document_id.setValidators([Validators.pattern("^[a-zA-Z0-9 \'\-]+$")])
        }
        else {
            this.debtorForm.controls.document_id.setValue("");
            this.debtorForm.controls.document_id.setValidators([Validators.required, Validators.pattern("^[0-9]*$")])
        }
    }
}
